import { NumberCondition, StringCondition } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { MeasurementUnit } from '../Reports/types';

export type BaseFormattingCondition = {
  id?: string;
  color: string;
};

export const endAdornmentMeasurementUnit = {
  [MeasurementUnit.Percentage]: '%',
  [MeasurementUnit.Days]: 'D',
  [MeasurementUnit.Hours]: 'H',
};

export const FormattingRuleType = {
  DIMENSION: 'DIMENSION',
  NUMERIC: 'NUMERIC',
} as const;

export type StringFilter = { expression?: { stringCondition: StringCondition } & { fieldName: string } };
export type DimensionFormattingCondition = BaseFormattingCondition & {
  filter?: StringFilter;
};

export type NumericFilter = { expression?: { numberCondition: NumberCondition } & { fieldName: string } };
export type NumericFormattingCondition = BaseFormattingCondition & {
  filter?: NumericFilter;
};

export type FormattingCondition = DimensionFormattingCondition | NumericFormattingCondition;

type BaseFormattingRule = {
  id?: string;
  name: string;
  description?: string;
  fallbackLogic: boolean;
};

export type DimensionFormattingRule = BaseFormattingRule & {
  type: typeof FormattingRuleType.DIMENSION;
  fieldName: string;
  formattingConditions: DimensionFormattingCondition[];
};

export type NumericFormattingRule = BaseFormattingRule & {
  type: typeof FormattingRuleType.NUMERIC;
  fieldName: null;
  formattingConditions: NumericFormattingCondition[];
};

export type FormattingRule = DimensionFormattingRule | NumericFormattingRule;

export const FormattingRuleTypeTitles = {
  [FormattingRuleType.NUMERIC]: 'Numeric Rules',
  [FormattingRuleType.DIMENSION]: 'Dimension Based Rules',
};

export const FormattingRuleTypeOptions = [
  { title: FormattingRuleTypeTitles[FormattingRuleType.NUMERIC], value: FormattingRuleType.NUMERIC },
  { title: FormattingRuleTypeTitles[FormattingRuleType.DIMENSION], value: FormattingRuleType.DIMENSION },
];

export const FormattingRuleMessageByType = {
  [FormattingRuleType.DIMENSION]:
    'Dimension-based formatting rules can be applied to Pie, Bar, and Table charts only; Repeated fields aren’t supported yet.',
  [FormattingRuleType.NUMERIC]: 'Numeric rules apply only to measurements and are valid for count-based values.',
};

export const boxContainer = {
  ...flex.justifyBetweenCenter,
  gap: 1.5,
  px: 2.5,
  py: 1.5,
  border: theme => `1px solid ${theme.palette.colors.neutrals[300]}`,
  borderTopRightRadius: '4px',
  borderBottomRightRadius: '4px',
};
